class NotificationPoller {
    constructor(endpoint, interval = 30000) {
        this.endpoint = endpoint;
        this.interval = interval;
        this.start();
    }

    start() {
        this.check();
        setInterval(() => this.check(), this.interval);
    }

    check() {
        fetch(this.endpoint)
            .then(res => {
                if (res.status === 204) return null;
                return res.json();
            })
            .then(data => {
                if (data && data.length) {
                    data.forEach(notification => {
                        if (!this.isDismissed(notification.id)) {
                            this.showToast(notification);
                        }
                    });
                }
            });
    }

    isDismissed(id) {
        // Check localStorage for dismissal entry
        const dismissUntil = localStorage.getItem(`toastDismiss_${id}`);
        if (!dismissUntil) return false;

        const now = new Date();
        return new Date(dismissUntil) > now;
    }

    dismissUntilTomorrow(id) {
        const now = new Date();
        const tomorrow = new Date(now);
        tomorrow.setHours(24, 0, 0, 0); // midnight tonight
        localStorage.setItem(`toastDismiss_${id}`, tomorrow.toISOString());
    }

	getColorClasses(type) {
		switch(type) {
			case 'success': 
				return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100';
			case 'danger': 
				return 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-100';
			case 'warning': 
				return 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-100';
			case 'info':
			default:
				return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-100';
		}
	}

	showToast(notification) {
		if (document.getElementById(`toast-${notification.id}`)) return;

		const container = document.getElementById('toast-container');
		if (!container) return;

		const type = notification.data.type || 'info';
		const colorClasses = this.getColorClasses(type);

		const toast = document.createElement('div');
		toast.id = `toast-${notification.id}`;
		toast.className = `px-3 py-2 rounded shadow-lg flex flex-col space-y-2 ${colorClasses} 
			transition transform duration-300 ease-out opacity-0 translate-x-4`;

		setTimeout(() => {
			toast.classList.remove('opacity-0', 'translate-x-4');
		}, 10);

		toast.innerHTML = `
			<div class="flex items-start justify-between w-full">
				<div class="break-words mr-2">${notification.data.message}</div>
				<button class="dismiss-btn text-2xl text-zinc-800 dark:text-zinc-200 hover:text-red-600 dark:hover:text-red-400 leading-none focus:outline-none cursor-pointer">&times;</button>
			</div>
			<div class="flex items-center mt-2">
				<label class="flex items-center text-sm cursor-pointer select-none space-x-2">
					<input type="checkbox" class="dont-show-again-checkbox cursor-pointer" />
					<span>Don't show again</span>
				</label>
			</div>
		`;

		container.appendChild(toast);

		const dismissBtn = toast.querySelector('button');
		const checkbox = toast.querySelector('.dont-show-again-checkbox');

		let autoDismissTimeout = setTimeout(() => this.removeToast(notification.id), 15000);

		dismissBtn.addEventListener('click', () => {
			this.removeToast(notification.id);
		});

		checkbox.addEventListener('change', (e) => {
			if (e.target.checked) {
				this.dismissUntilTomorrow(notification.id);
				this.removeToast(notification.id);
			}
		});

		toast.addEventListener('mouseenter', () => {
			clearTimeout(autoDismissTimeout);
		});
		toast.addEventListener('mouseleave', () => {
			autoDismissTimeout = setTimeout(() => this.removeToast(notification.id), 15000);
		});
	}

	removeToast(id) {
		const toast = document.getElementById(`toast-${id}`);
		if (!toast) return;
		toast.classList.add('opacity-0', 'translate-x-4', 'transition', 'duration-300', 'ease-in');
		setTimeout(() => toast.remove(), 300);
	}
}

export default NotificationPoller;
